import React, { Fragment } from "react";
import { social } from "../data/dummydata";

const Footer = () => {
  return (
    <>
      <footer>
        {social.map((item, i) => (
          <Fragment key={i}>
            <a href={item.url} target="_blank" rel="noopener noreferrer">
              <i>{item.icon}</i>
            </a>
          </Fragment>
        ))}
        <p data-aos="zoom-in">Juan Manuel Blanco 2021</p>
      </footer>
    </>
  );
};

export default Footer;
